import '../../styles/components/pagination.scss';

class Pagination extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.closest('.shopify-section').id.replace('shopify-section-', '');
    this.paginationContainer = document.querySelector('[data-pagination-container]');
    
    this.initializePagination();
  }

  initializePagination() {
    this.paginationLinks = Array.from(this.querySelectorAll('[data-pagination-link]'));


    this.paginationLinks.forEach(link => {
      link.addEventListener('click', this.paginationClick.bind(this))
    })
  }

  async paginationClick(event) {
    event.preventDefault();

    this.paginationContainer.classList.add('loading-state');
    const currentLink = event.currentTarget;

    const currentUrl = new URL(window.location.href);
    const pageLinkUrl = new URL(currentLink.href);
    const newPage = pageLinkUrl.searchParams.get('page');

    currentUrl.searchParams.set('page', newPage);
    const newUrl = currentUrl.toString();

    currentUrl.searchParams.set('section_id', this.sectionId);
    const sectionUpdateResponse = await fetch(currentUrl.toString());
    const sectionUpdateText = await sectionUpdateResponse.text();

    const tempElement = document.createElement('div');
    tempElement.innerHTML = sectionUpdateText;

    const newProducts = tempElement.querySelector('[data-pagination-container]');
    this.paginationContainer.innerHTML = newProducts.innerHTML;

    window.history.pushState(null, null, newUrl);

    this.paginationContainer.classList.remove('loading-state');

    window.scrollTo({
      top: this.paginationContainer.getBoundingClientRect().top + window.pageYOffset - 150,
      behavior: 'smooth'
    });

    this.initializePagination();
  }
}

try {
  customElements.define('pagination-element', Pagination);
}
catch(e) {
  console.log("pagination-element already defined", e)
}